import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUserAvatarSrc, isGroup } from '../../../User/helpers';
import AvatarImage from '../../AvatarImage';
var BasicUserAvatar = function (_a) {
    var _b;
    var user = _a.user, height = _a.size, className = _a.className, ariaHidden = _a["aria-hidden"], _c = _a.enableLazyLoad, enableLazyLoad = _c === void 0 ? true : _c;
    var t = useTranslation().t;
    var imgSrc = (_b = getUserAvatarSrc(user)) !== null && _b !== void 0 ? _b : undefined;
    var width = user && isGroup(user) ? 2 * height : height;
    return (React.createElement(AvatarImage, { width: width, height: height, src: imgSrc, className: className, alt: ariaHidden === 'true'
            ? ''
            : t('avatar.alt', {
                username: (user === null || user === void 0 ? void 0 : user.username) || t('avatar.unknownUser'),
            }), "aria-hidden": ariaHidden, enableLazyLoad: enableLazyLoad }));
};
BasicUserAvatar.displayName = 'BasicUserAvatar';
export default BasicUserAvatar;
//# sourceMappingURL=BasicUserAvatar.js.map